import React, { useContext, useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";

//importing context consumer here
import { UserContext } from "../contexts/User";
//functions
import { getCookie, getOffline } from "../functions/Functions";
import { BASE_URL } from "../BaseUrl";
import CustomSpinLoader from "../resources/components/CustomSpinLoader";
import BellRing from "../resources/restaurant/auth/modal/BellRing";
import { RestaurantContext } from "../contexts/Restaurant";

const checkAuthorization = () => {
  const userUrl = BASE_URL + "/auth/user";
  return getOffline(userUrl);
};
//3rd party packages
const RestaurantRoute = ({ children, ...rest }) => {

  //getting context values here
  const { authUserInfo } = useContext(UserContext);
  let { bellRing, setBellRing, audioInstance } = useContext(RestaurantContext);
  const [isAuthorized, setIsAuthorized] = useState(null); // null means loading

  //close bell ring
  const handleBellRingClose = () =>{
    setBellRing(false);
    if(audioInstance.current){
      audioInstance.current.pause();
      audioInstance.current.currentTime = 0;
    }
  }

  useEffect(() => {
    const fetchAuthorization = async () => {
      const authorizedUser = await checkAuthorization();
      setIsAuthorized(authorizedUser);
    };
  
    fetchAuthorization();
  }, []);

  const isLoggedIn = getCookie() !== undefined || isAuthorized;
  const isLoading = !getCookie() && (isAuthorized === null);
  const isCustomer = authUserInfo?.details && authUserInfo.details?.user_type === "customer";

  if(isLoading){
    return(
      <>
        <CustomSpinLoader loading={true}/>
        <Route
          {...rest}
          render={()=>children}
        ></Route>
      </>
    )
  }
  //redirect if customer
  if (isCustomer) {
    return (
      <Route
        render={() => {
          return (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        }}
      ></Route>
    );
  }

  return (
    <Route
      {...rest}
      render={() => {
        return isLoggedIn ? (
          <>
            <BellRing bellRing={bellRing} handleBellRingClose={handleBellRingClose} type="primary"/>
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { alert: "You need to login first!" },
            }}
          />
        );
      }}
    ></Route>
  );
};
export default RestaurantRoute;
